// Initializes Google Analytics 4 tracking
// @param {string} measurementId - Your GA4 Measurement ID
export const initializeGA = (measurementId) => {
  if (typeof window !== "undefined" && !window.GA_INITIALIZED) {
    // Insert the gtag.js script
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    // Insert the gtag config script
    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}');
    `;
    document.head.appendChild(inlineScript);

    window.GA_INITIALIZED = true;
  }
};
